module.exports = __webpack_public_path__ + "img/cf.da0ec0b8.svg";